"use client";
import { useState, useEffect } from "react";
import Script from "next/script";

const BitrixScript = () => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const shadowHost = document.querySelector('#voiceflow-chat');
  const shadowRoot = shadowHost?.shadowRoot;
  const btn = shadowRoot?.querySelector('button.vfrc-launcher');

  if (btn) {
    btn.id = 'liveaichat';
  }
  useEffect(() => {
    // Delay the script load by 5 seconds
    const timeout = setTimeout(() => {
      setIsScriptLoaded(true);
    }, 5000);

    return () => clearTimeout(timeout); // Cleanup on unmount
  }, []);

  return (
    <>
      <Script
        src="https://cdn.voiceflow.com/widget/bundle.mjs"
        type="text/javascript"
        strategy="afterInteractive"
        onLoad={() => {
          window.voiceflow.chat
            .load({
              verify: { projectID: '667478e3f19f313963bb1525' },
              url: 'https://general-runtime.voiceflow.com',
              versionID: 'production',
            })
            .then(() => {
              setTimeout(() => {
                window.voiceflow.chat.proactive.push({
                  type: 'text',
                  payload: { message: 'Hi, I am Fatima!' },
                });
              }, 1500);
              setTimeout(() => {
                window.voiceflow.chat.proactive.push({
                  type: 'text',
                  payload: {
                    message: 'Ask me your question, I will be glad to help!',
                  },
                });
              }, 3000);
            });
        }}
      />
    </>
  );
};

export default BitrixScript;
